import { useCallback, useLayoutEffect, useRef } from 'react';
import { useLatestRef } from '@gonfalon/react/useLatestRef';

export function useCallbackIfMounted<TArgs extends readonly unknown[], TReturn>(
  callback: (...args: TArgs) => TReturn,
  _deps?: readonly unknown[],
): (...args: TArgs) => TReturn | undefined {
  const isMounted = useRef(false);
  const callbackRef = useLatestRef(callback);

  useLayoutEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  return useCallback(
    (...params: TArgs) => {
      if (isMounted.current) {
        return callbackRef.current(...params);
      }
      return undefined;
    },
    [callbackRef],
  );
}
